import { useState, useEffect } from 'react';
import { Navigation } from '../../../components/feature/Navigation';

export function HeroSection() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToContact = () => {
    const contactSection = document.getElementById('contact-section');
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* 背景画像 */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://public.readdy.ai/ai/img_res/34c5346de029a58b857a5a420c5d78b5.jpg"
          alt="太陽光発電パネル設置住宅"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      </div>

      {/* ナビゲーション */}
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white shadow-md' : 'bg-transparent'}`}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-20">
            <div className="flex items-center space-x-3">
              <img 
                src="https://readdy.ai/api/search-image?query=Professional%20clean%20energy%20company%20logo%20design%20with%20solar%20panel%20and%20sun%20symbol%20in%20emerald%20green%20and%20gold%20colors%2C%20modern%20minimalist%20style%2C%20circular%20badge%20shape%2C%20representing%20renewable%20energy%20and%20sustainability%20for%20Hokuriku%20Clean%20Energy%20company%2C%20simple%20white%20background%2C%20high%20quality%20vector%20style%20illustration&width=200&height=200&seq=logo-hokuriku-clean-energy-001&orientation=squarish" 
                alt="北陸クリーンエネルギー" 
                className="h-12 w-auto"
              />
              <div className={`transition-colors duration-300 ${isScrolled ? 'text-gray-900' : 'text-white'}`}>
                <div className="font-bold text-lg leading-tight">北陸クリーンエネルギー</div>
                <div className="text-xs opacity-70">Hokuriku Clean Energy</div>
              </div>
            </div>
            <Navigation isScrolled={isScrolled} />
          </div>
        </div>
      </nav>

      {/* メインコンテンツ */}
      <div className="relative z-10 w-full max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 pt-32 pb-20 text-center">
        <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight">
          <span className="text-emerald-400">太陽光発電</span>を賢く使って、<br className="hidden sm:block" />
          電気代を<span className="text-emerald-400">大幅削減。</span>
        </h1>
        
        <p className="text-lg sm:text-xl text-white/95 mb-10 max-w-3xl mx-auto leading-relaxed">
          北陸の気候を知り尽くした地元・金沢のプロが、<br />
          太陽光・住宅リフォーム事業に携わってきた長年の経験・知識を活かして、<br className="hidden sm:block" />
          ご提案から補助金申請、施工、アフターフォローまで丸ごとサポート
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-12">
          <button
            onClick={scrollToContact}
            className="w-full sm:w-auto bg-emerald-500 hover:bg-emerald-600 text-white px-8 py-4 rounded-lg font-bold text-lg transition-all duration-300 shadow-xl hover:shadow-2xl hover:scale-105 whitespace-nowrap"
          >
            <i className="ri-calculator-line mr-2"></i>
            無料診断
          </button>
          <a
            href="tel://0762553483"
            className="w-full sm:w-auto bg-white hover:bg-gray-50 text-emerald-600 px-8 py-4 rounded-lg font-bold text-lg transition-all duration-300 shadow-xl hover:shadow-2xl hover:scale-105 whitespace-nowrap"
          >
            <i className="ri-phone-fill mr-2"></i>
            今すぐ電話で相談
          </a>
        </div>

        {/* 信頼の証 */}
        <div className="flex flex-wrap items-center justify-center gap-6 text-white/90 text-sm">
          <div className="flex items-center space-x-2">
            <i className="ri-shield-check-line text-2xl text-emerald-400"></i>
            <span className="font-medium">納得の安心価格！</span>
          </div>
          <div className="flex items-center space-x-2">
            <i className="ri-snowy-line text-2xl text-emerald-400"></i>
            <span className="font-medium">万全のアフターフォローで安心</span>
          </div>
          <div className="flex items-center space-x-2">
            <i className="ri-file-list-3-line text-2xl text-emerald-400"></i>
            <span className="font-medium">補助金申請代行</span>
          </div>
        </div>
      </div>

      {/* スクロールインジケーター */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-10 animate-bounce">
        <i className="ri-arrow-down-line text-3xl text-white/80"></i>
      </div>
    </section>
  );
}
